<template>
  <main>nothing to see here</main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>
